module.exports = __webpack_public_path__ + "img/attraction-3-old.25de05c0.jpg";